export default "__VITE_ASSET__FG30CJrY__"